import ApiService from './ApiService';

const AVATAR =
  'https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/b5/b5bd56c1aa4644a474a2e4972be27ef9e82e517e_full.jpg';

const TEST_GIFTCODE_ONE = {
  game: {
    thumbnail:
      'https://www.guinnessworldrecords.com/Images/GTA-V-main_tcm25-19095.jpg',
    name: 'GTA 5',
    region: 'EUROPE',
    description: 'Awesome description',
    releaseDate: '',
  },
};

const TEST_GIFTCODE_TWO = {
  ...TEST_GIFTCODE_ONE,
  user: { id: '123456', name: 'charlibelle86', avatar: AVATAR },
};

const TEST_GIFTCODE_THREE = {
  ...TEST_GIFTCODE_TWO,
  country: { name: 'Russia', code: 'RU' },
  userAgreed: true,
  bot: { name: 'awesome_bot', avatar: AVATAR },
};

const TEST_GIFTCODE_FOUR = {
  ...TEST_GIFTCODE_THREE,
  friendRequest: { status: 'DONE', updatedAt: new Date().getTime() },
};

const TEST_GIFTCODE_FULL = {
  ...TEST_GIFTCODE_FOUR,
  transferStatus: 'done',
  bonusCode: 'bonusCode',
  // Stale legacy error kept after a manual OK: on DONE the error Alert must not show
  error: {
    code: 102,
    title: 'Legacy engine error kept after a manual OK',
    type: 0,
  },
  // error: { //optional
  //   code: 0 //TODO define values
  //   title: ”Short error description”
  //   type: 0 - warning (user is able to retry) 1- error (activation failed)
  //   description: 'error description”
  //   details:JsonObject //optional
  // }
};

// Quick Invite flow: the backend returns the user with quickInvite only, no bot, no friend request
const TEST_GIFTCODE_QUICK = {
  ...TEST_GIFTCODE_ONE,
  user: { quickInvite: 'https://s.team/p/fbnq-dnnq/JXKPGVBW' },
  country: { name: 'Russia', code: 'RU' },
  userAgreed: true,
};

// "Stuck" order: transfer started 12 minutes ago — the "taking longer" hint and the backend-field stopwatch
export const STUCK_TRANSFER_AGE_MS = 12 * 60 * 1000;
const TEST_GIFTCODE_STUCK = {
  ...TEST_GIFTCODE_QUICK,
  transferStatus: 'ACCEPTED',
};
// The stuck order's start is computed once: recomputing it on every GET would move it forward and run the stopwatch backwards
let stuckStartedAt = null;
function stuckTransferStart() {
  if (stuckStartedAt === null)
    stuckStartedAt = Date.now() - STUCK_TRANSFER_AGE_MS;
  return stuckStartedAt;
}

const MOCKS = {
  TEST_GIFTCODE_FULL,
  TEST_GIFTCODE_EMPTY: {},
  TEST_GIFTCODE_ONE,
  TEST_GIFTCODE_TWO,
  TEST_GIFTCODE_THREE,
  TEST_GIFTCODE_FOUR,
  TEST_GIFTCODE_QUICK,
  TEST_GIFTCODE_CANCELED: TEST_GIFTCODE_QUICK,
  TEST_GIFTCODE_STUCK,
};
const MOCK_DELAY_MS = 3000;

// Гифт-код чужого сайта: бэкенд отвечает 400 с ошибкой 107 (ActivationService.activate)
const TEST_GIFTCODE_FOREIGN_ERROR = {
  error: { code: 107, title: 'Gift code is not valid', type: 1 },
};

export function resolveMock(giftcode) {
  if (!Object.prototype.hasOwnProperty.call(MOCKS, giftcode)) return null;
  const mock = MOCKS[giftcode];
  return giftcode === 'TEST_GIFTCODE_STUCK'
    ? { ...mock, transferStartedAt: stuckTransferStart() }
    : mock;
}

// GET status scenarios: one step per poll, the last step repeats; a different code resets
const HAPPY_PATH = [null, 'ACCEPTED', 'PREPARED', 'DELIVERING', 'DELIVERED'];
const TRANSFER_SCENARIOS = {
  TEST_GIFTCODE_CANCELED: [null, 'ACCEPTED', 'CANCELED'],
  TEST_GIFTCODE_STUCK: ['ACCEPTED'],
};
let scenario = null;

export function mockTransferStatus(giftcode) {
  if (!scenario || scenario.giftcode !== giftcode) {
    scenario = { giftcode, polls: 0 };
    if (giftcode !== 'TEST_GIFTCODE_STUCK') stuckStartedAt = null;
  }
  const steps = TRANSFER_SCENARIOS[giftcode] || HAPPY_PATH;
  const status = steps[Math.min(scenario.polls, steps.length - 1)];
  scenario.polls += 1;

  const payload = {};
  if (status) payload.transferStatus = status;
  if (status === 'DELIVERED') payload.bonusCode = 'BONUS-DEMO-CODE';
  if (giftcode === 'TEST_GIFTCODE_STUCK') {
    payload.transferStartedAt = stuckTransferStart();
  }
  return payload;
}

function mockResolve(value, delay) {
  return new Promise((resolve) => setTimeout(resolve, delay, value));
}

function mockReject(reason, delay) {
  return new Promise((_, reject) => setTimeout(reject, delay, reason));
}

function upperCaseFriendRequestAndTransferStatus(payload) {
  if (payload && payload.friendRequest && payload.friendRequest.status) {
    payload.friendRequest.status = payload.friendRequest.status.toUpperCase();
  }

  if (payload && payload.transferStatus) {
    payload.transferStatus = payload.transferStatus.toUpperCase();
  }

  return payload;
}

function pickGameFields({
  transferStatus,
  transferStartedAt,
  bonusCode,
  error,
  phase,
}) {
  return { transferStatus, transferStartedAt, bonusCode, error, phase };
}

export default {
  async fetchMain(giftcode, _market, data = null) {
    if (giftcode === 'TEST_GIFTCODE_FOREIGN') {
      return mockReject(TEST_GIFTCODE_FOREIGN_ERROR, MOCK_DELAY_MS);
    }
    const mock = resolveMock(giftcode);
    if (mock) {
      return mockResolve(
        upperCaseFriendRequestAndTransferStatus({ ...mock }),
        MOCK_DELAY_MS
      );
    }
    return ApiService.put(`/activation/${giftcode}`, data).then(
      upperCaseFriendRequestAndTransferStatus
    );
  },
  sendUrl(giftcode, url) {
    return ApiService.post(`/activation/${giftcode}/account`, {
      quickInvite: url,
    });
  },
  setCountry(giftcode, code) {
    return ApiService.post(`/activation/${giftcode}/country`, {
      code,
      name: 'Name',
    }).then(() => ({ code }));
  },
  changeAccount(giftcode) {
    return ApiService.delete(`/activation/${giftcode}/account`);
  },
  getFriendRequest(giftcode) {
    return ApiService.get(`/activation/${giftcode}`)
      .then(upperCaseFriendRequestAndTransferStatus)
      .then(({ bot, friendRequest, error, phase }) => ({
        bot,
        friendRequest,
        error,
        phase,
      }));
  },
  setUserAgree(giftcode) {
    return ApiService.post(`/activation/${giftcode}/user_agreed`);
  },
  getGame(giftcode) {
    if (resolveMock(giftcode)) {
      return mockResolve(
        upperCaseFriendRequestAndTransferStatus(mockTransferStatus(giftcode)),
        600
      ).then(pickGameFields);
    }
    return ApiService.get(`/activation/${giftcode}`)
      .then(upperCaseFriendRequestAndTransferStatus)
      .then(pickGameFields);
  },
};
